import React, { useState } from "react";

const label = (k) => k.replace(/_/g, " ").replace(/\b\w/g, (m) => m.toUpperCase());

const Leaf = ({ path, value, onChange }) => {
  const tid = `ro-admin-${path.join("-")}`;
  if (typeof value === "boolean") {
    return <input data-testid={tid} type="checkbox" checked={value} onChange={(e) => onChange(e.target.checked)} className="accent-[#C6A15B]" />;
  }
  if (typeof value === "number") {
    return <input data-testid={tid} type="number" step="any" value={value} onChange={(e) => onChange(e.target.value === "" ? 0 : Number(e.target.value))} className="input-exodus py-2 font-mono text-xs" />;
  }
  if (Array.isArray(value)) {
    return <ArrayText tid={tid} value={value} onChange={onChange} />;
  }
  return <input data-testid={tid} value={value ?? ""} onChange={(e) => onChange(e.target.value)} className="input-exodus py-2 text-xs" />;
};

const ArrayText = ({ tid, value, onChange }) => {
  const [txt, setTxt] = useState(value.join(", "));
  return <input data-testid={tid} value={txt} className="input-exodus py-2 font-mono text-xs"
    onChange={(e) => { setTxt(e.target.value); onChange(e.target.value.split(",").map((x) => Number(x.trim())).filter((x) => Number.isFinite(x))); }} />;
};

export const SettingsEditor = ({ value, onChange, path = [] }) => {
  const set = (k, v) => onChange(Array.isArray(value) ? value.map((x, i) => (i === k ? v : x)) : { ...value, [k]: v });
  const entries = Array.isArray(value) ? value.map((v, i) => [i, v]) : Object.entries(value);
  return (
    <div className={path.length ? "pl-4 border-l border-exodus-border space-y-3" : "space-y-6"}>
      {entries.map(([k, v]) => {
        const nested = v && typeof v === "object" && !(Array.isArray(v) && v.every((x) => typeof x === "number"));
        const name = Array.isArray(value) ? `#${k + 1}` : label(String(k));
        return nested ? (
          <details key={k} open={path.length < 1} className="group">
            <summary className={`cursor-pointer ${path.length ? "text-xs text-exodus-text" : "eyebrow gold-text"} py-1`}>{name}</summary>
            <div className="mt-3">{React.createElement(SettingsEditor, { value: v, onChange: (nv) => set(k, nv), path: [...path, k] })}</div>
          </details>
        ) : (
          <div key={k} className="grid grid-cols-[1fr_1.2fr] gap-3 items-center">
            <span className="text-xs text-exodus-muted">{name}</span>
            <Leaf path={[...path, k]} value={v} onChange={(nv) => set(k, nv)} />
          </div>
        );
      })}
    </div>
  );
};
